import React, { forwardRef } from 'react';
import { CloseIcon } from '@panwds/icons';
import { classNames, testIdGen } from '@panwds/react-ui';

/**
 * The UI treatment for the filters in a filter bar
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Pill } from "@panwds/react-filters";
 * ```
 */
const Pill = forwardRef((props, ref) => {
    const { dataMetrics, dataTestId, select, label, onClose, required } = props;
    const parentDivClassname = classNames("tw-text-gray-900 dark:tw-text-gray-400 tw-rounded tw-font-lato tw-box-border tw-border-solid tw-border-gray-300 tw-m-0 tw-flex tw-leading-5 tw-items-center tw-h-8 tw-min-w-0 tw-pl-2 tw-pr-3 tw-pb-0 tw-pt-0 tw-bg-white dark:tw-bg-gray-1050 tw-border focus:tw-outline-none dark:tw-border-gray-900 focus:tw-ring hover:tw-bg-blue-100 hover:tw-border-blue-600 dark:hover:tw-border-blue-400 tw-text-link dark:tw-text-dark-bg-link");
    const keyClassName = classNames("tw-inline-flex tw-items-center tw-flex-shrink-0 tw-font-bold");
    const buttonClassname = classNames("tw-box-border tw-border-0 tw-bg-transparent tw-flex tw-ml-1 tw-mt-0 tw-mb-0 tw-mr-0 tw-p-1 tw-text-icon-gray", "hover:tw-text-secondary focus:tw-outline-none focus:tw-ring");
    const closeButton = (React.createElement("button", { "aria-label": "remove filter", className: buttonClassname, onClick: onClose, type: "button", "data-testid": "remove-filter" },
        React.createElement(CloseIcon, { size: "xxs" })));
    const showColon = () => {
        const selectProps = select.props;
        if (selectProps.defaultValues ||
            selectProps.placeholder ||
            selectProps.filterValue) {
            return (React.createElement("strong", { className: "tw-text-gray-900 dark:tw-text-gray-400" }, ": "));
        }
        return null;
    };
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || `pill-${testIdGen(label)}`, className: parentDivClassname, ref: ref },
        React.createElement("div", { className: keyClassName },
            React.createElement("span", { className: "tw-leading-5 tw-text-gray-900 dark:tw-text-gray-400" }, label),
            showColon(),
            React.createElement("span", null, select),
            !required && closeButton)));
});
Pill.displayName = "Pill";

export { Pill };
//# sourceMappingURL=Pill.esm.js.map
